'use client';

import { Flex, Box } from '@skin-seoul/design-system';
import { CAMPAIGN_SCHEDULE, isBeforeNowInTimeZone, getActiveYearEndFlashSaleRotation } from '@skin-seoul/service';
import { CampaignBanner } from './components/CampaignBanner';
import { YearEndCampaignProductSwiper } from './components/YearEndCampaignProductSwiper';
import { CampaignTextBanner } from './components/CampaignTextBanner';
import SectionContainer from '@/components/shared/SectionContainer';
import SectionHeader from '@/containers/home/components/SectionHeader';
const CAMPAIGN_BANNER_TITLE = 'Flash sale ends soon';
const CAMPAIGN_BANNER_SUBTITLE = 'Up to 50% OFF on selected items';
export const YearEndCampaignSection = () => {
  const isCampaignActive = isBeforeNowInTimeZone(CAMPAIGN_SCHEDULE.YEAR_END.endDate, CAMPAIGN_SCHEDULE.YEAR_END.timeZone);
  const activeRotation = getActiveYearEndFlashSaleRotation();
  if (!isCampaignActive || !activeRotation) {
    return null;
  }
  return <SectionContainer containerWrapperProps={{
    backgroundColor: 'generic.0'
  }} containerInnerProps={{
    gap: {
      base: 6,
      desktop: 8
    },
    paddingTop: {
      base: 6,
      desktop: 8
    },
    paddingBottom: {
      base: 2,
      desktop: 0
    },
    paddingRight: {
      base: 0,
      tablet: 6
    }
  }} data-sentry-element="SectionContainer" data-sentry-component="YearEndCampaignSection" data-sentry-source-file="YearEndCampaignSection.tsx">
      <Box paddingRight={{
      base: 4,
      tablet: 0
    }} data-sentry-element="Box" data-sentry-source-file="YearEndCampaignSection.tsx">
        <CampaignBanner endDate={activeRotation.endDate} title={CAMPAIGN_BANNER_TITLE} subtitle={CAMPAIGN_BANNER_SUBTITLE} data-sentry-element="CampaignBanner" data-sentry-source-file="YearEndCampaignSection.tsx" />
      </Box>
      <Flex direction="column" data-sentry-element="Flex" data-sentry-source-file="YearEndCampaignSection.tsx">
        <Box width="100%" backgroundColor="neutral.50" borderTopRadius="12px" paddingY={{
        base: 4,
        desktop: 8
      }} paddingLeft={{
        base: 4,
        desktop: 8
      }} paddingRight={{
        base: 0,
        desktop: 8
      }} data-sentry-element="Box" data-sentry-source-file="YearEndCampaignSection.tsx">
          <Flex direction="column" gap={{
          base: 6,
          desktop: 8
        }} data-sentry-element="Flex" data-sentry-source-file="YearEndCampaignSection.tsx">
            <SectionHeader href={activeRotation.campaignUrl} title="Flash Sale" data-sentry-element="SectionHeader" data-sentry-source-file="YearEndCampaignSection.tsx" />
            <YearEndCampaignProductSwiper collectionName={activeRotation.collectionName} data-sentry-element="YearEndCampaignProductSwiper" data-sentry-source-file="YearEndCampaignSection.tsx" />
          </Flex>
        </Box>
        <CampaignTextBanner data-sentry-element="CampaignTextBanner" data-sentry-source-file="YearEndCampaignSection.tsx" />
      </Flex>
    </SectionContainer>;
};